<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-button v-if="isAuth('workflow:task:list')" type="primary" size="small" @click="pageIndex = 1; load()">刷新</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageRows" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" :index="indexMethod" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="bizCode" label="单据号" min-width="140" header-align="center" align="left">
        <template slot-scope="s">
          <a v-if="canViewDoc(s.row)" class="code-link" @click="openDoc(s.row)">{{ s.row.bizCode }}</a>
          <span v-else>{{ s.row.bizCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="bizType" label="单据类型" width="120" header-align="center" align="left">
        <template slot-scope="s">{{ bizTypeLabel(s.row.bizType) }}</template>
      </el-table-column>
      <el-table-column prop="stepName" label="当前步骤" width="120" header-align="center" align="left" />
      <el-table-column prop="createDate" label="到达时间" width="160" header-align="center" align="left" />
      <el-table-column label="操作" width="160" header-align="center" align="center">
        <template slot-scope="s">
          <el-button v-if="isAuth('workflow:task:approve')" type="text" size="small" @click="approveHandle(s.row)">通过</el-button>
          <el-button v-if="isAuth('workflow:task:reject')" type="text" size="small" @click="rejectHandle(s.row)">驳回</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="v => { pageIndex = v }"
      @size-change="v => { pageSize = v; pageIndex = 1 }"
      :current-page="pageIndex" :page-size="pageSize" :total="all.length"
      layout="total, sizes, prev, pager, next" style="margin-top:12px" />
    <div v-show="false">
      <component :is="pageComp" v-if="pageComp" ref="page" />
    </div>
  </div>
</template>

<script>
import request from '../../api/request'
import auth from './workflowAuth'
const DOCS = {
  purchaseRequisition: { perm: 'purchase:purchaseRequisition:info', load: () => import('../purchase/purchaseRequisition.vue') },
  purchaseInquiry: { perm: 'purchase:purchaseInquiry:info', load: () => import('../purchase/purchaseInquiry.vue') },
  purchaseArrivalNotice: { perm: 'purchase:purchaseArrivalNotice:info', load: () => import('../purchase/purchaseArrivalNotice.vue') },
  purchaseIncomingInspection: { perm: 'purchase:purchaseIncomingInspection:info', load: () => import('../purchase/purchaseIncomingInspection.vue') },
  purchaseStockIn: { perm: 'purchase:purchaseStockIn:info', load: () => import('../purchase/purchaseStockIn.vue') },
  purchaseReturn: { perm: 'purchase:purchaseReturn:info', load: () => import('../purchase/purchaseReturn.vue') },
  purchaseStockReturn: { perm: 'purchase:purchaseStockReturn:info', load: () => import('../purchase/purchaseStockReturn.vue') },
  salesShippingNotice: { perm: 'sale:salesShippingNotice:info', load: () => import('../sale/salesShippingNotice.vue') },
  salesStockOut: { perm: 'sale:salesStockOut:info', load: () => import('../sale/salesStockOut.vue') },
  salesReturn: { perm: 'sale:salesReturn:info', load: () => import('../sale/salesReturn.vue') },
  salesStockReturn: { perm: 'sale:salesStockReturn:info', load: () => import('../sale/salesStockReturn.vue') },
  salePriceList: { perm: 'sale:salePriceList:info', load: () => import('../sale/SalePriceList.vue') },
  otherIn: { perm: 'inventory:otherIn:info', load: () => import('../inventory/OtherIn.vue') },
  otherOut: { perm: 'inventory:otherOut:info', load: () => import('../inventory/OtherOut.vue') },
  transfer: { perm: 'inventory:transfer:info', load: () => import('../inventory/Transfer.vue') },
  counting: { perm: 'inventory:counting:info', load: () => import('../inventory/Counting.vue') },
  assemble: { perm: 'inventory:assemble:info', load: () => import('../inventory/Assemble.vue') },
  disassembly: { perm: 'inventory:disassembly:info', load: () => import('../inventory/Disassembly.vue') },
  ratioIn: { perm: 'inventory:ratioIn:info', load: () => import('../inventory/RatioIn.vue') },
  ratioOut: { perm: 'inventory:ratioOut:info', load: () => import('../inventory/RatioOut.vue') },
  productionIssue: { perm: 'production:productionIssue:info', load: () => import('../production/productionIssue.vue') },
  productionReturn: { perm: 'production:productionReturn:info', load: () => import('../production/productionReturn.vue') },
  productionReceipt: { perm: 'production:productionReceipt:info', load: () => import('../production/productionReceipt.vue') },
  productionReport: { perm: 'production:productionReport:info', load: () => import('../production/productionReport.vue') },
  productionSettle: { perm: 'production:productionSettle:info', load: () => import('../production/productionSettle.vue') },
  plannedOrder: { perm: 'production:plannedOrder:list', load: () => import('../production/plannedOrder.vue') },
  mpsSchedule: { perm: 'production:mpsSchedule:list', load: () => import('../production/mpsSchedule.vue') },
  receivable: { perm: 'finance:receivable:info', load: () => import('../finance/Receivable.vue') },
  payable: { perm: 'finance:payable:info', load: () => import('../finance/Payable.vue') },
  invoiceSales: { perm: 'finance:invoiceSales:info', load: () => import('../finance/InvoiceSales.vue') },
  invoiceSalesRed: { perm: 'finance:invoiceSalesRed:info', load: () => import('../finance/InvoiceSalesRed.vue') },
  invoicePurchase: { perm: 'finance:invoicePurchase:info', load: () => import('../finance/InvoicePurchase.vue') },
  invoicePurchaseRed: { perm: 'finance:invoicePurchaseRed:info', load: () => import('../finance/InvoicePurchaseRed.vue') },
  receipt: { perm: 'finance:receipt:info', load: () => import('../finance/Receipt.vue') },
  receiptRed: { perm: 'finance:receiptRed:info', load: () => import('../finance/ReceiptRed.vue') },
  payment: { perm: 'finance:payment:info', load: () => import('../finance/Payment.vue') },
  paymentRed: { perm: 'finance:paymentRed:info', load: () => import('../finance/PaymentRed.vue') },
  advanceReceipt: { perm: 'finance:advanceReceipt:info', load: () => import('../finance/AdvanceReceipt.vue') },
  advancePayment: { perm: 'finance:advancePayment:info', load: () => import('../finance/AdvancePayment.vue') },
  salesReturnSettle: { perm: 'finance:salesReturnSettle:info', load: () => import('../finance/SalesReturnSettle.vue') },
  purchaseReturnSettle: { perm: 'finance:purchaseReturnSettle:info', load: () => import('../finance/PurchaseReturnSettle.vue') }
}

export default {
  name: 'WorkflowTask',
  mixins: [auth],
  data() {
    return { bizTypeOptions: [], all: [], loading: false, pageIndex: 1, pageSize: 20, pageComp: null, headStyle: { background: '#f5f7fa', color: '#606266' } }
  },
  computed: {
    pageRows() {
      const start = (this.pageIndex - 1) * this.pageSize
      return this.all.slice(start, start + this.pageSize)
    }
  },
  created() { this.loadBizTypes(); this.load() },
  activated() { this.loadBizTypes(); this.load() },
  methods: {
    loadBizTypes() {
      request.get('/workflow/definition/bizTypes').then(res => {
        this.bizTypeOptions = (res.data || []).map(item => ({ value: item.docType, label: item.docName }))
      }).catch(() => {})
    },
    bizTypeLabel(value) {
      const hit = this.bizTypeOptions.find(o => o.value === value)
      return hit ? hit.label : value
    },
    indexMethod(index) { return (this.pageIndex - 1) * this.pageSize + index + 1 },
    canViewDoc(row) {
      const cfg = DOCS[row.bizType]
      return !!(cfg && this.isAuth(cfg.perm))
    },
    openDoc(row) {
      const cfg = DOCS[row.bizType]
      if (!row.bizId) { this.$message.warning('单据ID缺失'); return }
      if (!cfg) { this.$message.warning('暂不支持查看该类型单据'); return }
      if (!this.isAuth(cfg.perm)) { this.$message.warning('无查看该单据的权限'); return }
      cfg.load().then(mod => {
        this.pageComp = mod.default
        this.$nextTick(() => {
          const page = this.$refs.page
          if (!page) return
          if (typeof page.open === 'function') page.open(row.bizId, true)
          else if (typeof page.addOrUpdateHandle === 'function') page.addOrUpdateHandle(row.bizId, true)
          else this.$message.warning('暂不支持查看该类型单据')
        })
      }).catch(() => this.$message.error('打开单据详情失败'))
    },
    load() {
      this.loading = true
      request.post('/workflow/task/list', {}).then(res => { this.all = res.data || [] }).catch(() => { this.all = [] }).finally(() => { this.loading = false })
    },
    approveHandle(row) {
      this.$prompt('审批意见（可选）', '审批通过', { inputType: 'textarea', confirmButtonText: '通过' }).then(({ value }) => {
        request.post('/workflow/task/approve', { taskId: row.taskId, comment: value || '' }).then(() => {
          this.$message.success('审批通过')
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    rejectHandle(row) {
      this.$prompt('请输入驳回原因', '审批驳回', {
        inputType: 'textarea',
        confirmButtonText: '驳回',
        inputValidator: v => !!(v && String(v).trim()) || '驳回原因不能为空'
      }).then(({ value }) => {
        request.post('/workflow/task/reject', { taskId: row.taskId, comment: value.trim() }).then(() => {
          this.$message.success('已驳回')
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.code-link { color: #348adb; cursor: pointer; }
</style>
